import { render, staticRenderFns } from "./Works.vue?vue&type=template&id=92daa3ae&scoped=true&"
import script from "./Works.vue?vue&type=script&lang=js&"
export * from "./Works.vue?vue&type=script&lang=js&"
import style0 from "./Works.vue?vue&type=style&index=0&id=92daa3ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92daa3ae",
  null
  
)

export default component.exports